import React from "react";
import "./About4.css";
import { Link } from "react-router-dom";
import { BsArrowRight } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import AOS from 'aos'
import 'aos/dist/aos.css'
import { useEffect } from "react";

const About4 = () => {
  const navigate = useNavigate();

  const home = () => {
    navigate("/");
  };

  const nav=()=>{
    document.querySelector('.sub1-nav-items').style.display="flex"
    document.querySelector('.icon1-about').style.display="none";
    document.querySelector('.icon2-about').style.display="block"
  }

  const clonav=()=>{
    document.querySelector('.sub1-nav-items').style.display="none"
    document.querySelector('.icon1-about').style.display="block";
    document.querySelector('.icon2-about').style.display="none"
  }

   ///animation

   useEffect(()=>{
    AOS.init({duration:3000})
  },[])


  return (
    <section className="s-about4">
      <div className="sub1-section">
        <nav className="sub1-nav">
        <div className="logonav">
            <div className="sub1_logo" onClick={home}>
              <img src="./logo.png" alt="LOGO" className="sub1-logo" />
            </div>
            <div className='icon-about'>
            <div className='icon1-about' >
            <svg xmlns="http://www.w3.org/2000/svg" onClick={()=>nav()} class="icon icon-tabler icon-tabler-align-box-center-middle" width="60" height="40" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
              <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
              <path d="M3 19v-14a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"></path>
              <path d="M11 15h2"></path>
              <path d="M9 12h6"></path>
              <path d="M10 9h4"></path>
            </svg>
            </div>
            <div className='icon2-about'>
            <svg xmlns="http://www.w3.org/2000/svg" onClick={()=>clonav()} class="icon icon-tabler icon-tabler-xbox-x" width="60" height="40" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
              <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
              <path d="M12 21a9 9 0 0 0 9 -9a9 9 0 0 0 -9 -9a9 9 0 0 0 -9 9a9 9 0 0 0 9 9z"></path>
              <path d="M9 8l6 8"></path>
              <path d="M15 8l-6 8"></path>
            </svg>
            </div>
          </div>
          </div>
          <div className="sub1_navabar">
            <div className="sub1-nav-items">
              <Link className="sub1-nav-link" to="/">
                HOME
              </Link>
              <Link className="sub1-nav-link" to="/mabout">
                ABOUT
              </Link>
              <Link className="sub1-nav-link" to="/product">
                PRODUCT
              </Link>
              <Link className="sub1-nav-link" to="/contact">
                CONTACT
              </Link>
            </div>
          </div>
        </nav>
      </div>
      <div className="sub1-back">
        <div className="sub1-content" data-aos="fade-up"
     data-aos-duration="3000">
          <Link to="/" style={{ textDecoration: "none", color: "#000" }}>
            {" "}
            Home
          </Link>{" "}
          <BsArrowRight />{" "}
          <Link to="/mabout" style={{ textDecoration: "none", color: "#000" }}>
            {" "}
            About Us{" "}
          </Link>
        </div>
        <div className="sub1_img">
          <img src="./dal.png" alt="DAL" className="sub1-img" data-aos="fade-up"
     data-aos-duration="3000"/>
        </div>
      </div>
      <div className="swara" data-aos="fade-up"
     data-aos-duration="3000"></div>
      <div className="a4-section1">
        <div className="a4-info1">
          <div className="a4-sub-title1" data-aos="fade-up-right">
            One of the leading manufcturing company of pulses
          </div>
          <div className="a4-main-title1" data-aos="fade-up-right">JKSwara</div>
          <div className="main4-subtitle1"data-aos="fade-up-right">AGRO PROCESSING PVT LTD.</div>
          <div className="a4-sub-text1" data-aos="fade-up-right">
            We, JKSwara AGRO PROCESSING PRIVATE LIMITED are counted amidst the
            leading and reputed companies dealing in branded pulses in India. As
            a prominent player in the agro processing sector, WE have the
            opportunity to positively impact both farmers and consumers. By
            ensuring top-notch quality, WE build trust among OUR customers,
            which is key to sustaining and expanding our market presence. If
            there's anything specific you'd like to know or discuss about our
            company or the agro processing industry, feel free to ask. I'm here
            to assist you with any information or guidance you may need.
          </div>
        </div>
        <div className="a4-img1">
          <img
            src={require("../../assets/images/22.png")}
            alt="DAL"
            className="dal4_img1"
            data-aos="fade-up-left"
          />
        </div>
      </div>
      <div className="a4-section1-res">
        <div className="a4-img1">
          <img
            src={require("../../assets/images/22.png")}
            alt="DAL"
            className="dal4_img1"
            data-aos="fade-up-right"
          />
        </div>
        <div className="a4-info1">
          <div className="a4-sub-title1" data-aos="fade-up-left">
            One of the leading manufcturing company of pulses
          </div>
          <div className="a4-main-title1" data-aos="fade-up-left">JKSwara</div>
          <div className="main4-subtitle1" data-aos="fade-up-left">AGRO PROCESSING PVT LTD.</div>
          <div className="a4-sub-text1" data-aos="fade-up-left">
            We, JKSwara AGRO PROCESSING PRIVATE LIMITED are counted amidst the
            leading and reputed companies dealing in branded pulses in India. As
            a prominent player in the agro processing sector, WE have the
            opportunity to positively impact both farmers and consumers. By
            ensuring top-notch quality, WE build trust among OUR customers,
            which is key to sustaining and expanding our market presence. If
            there's anything specific you'd like to know or discuss about our
            company or the agro processing industry, feel free to ask. I'm here
            to assist you with any information or guidance you may need.
          </div>
        </div>
      </div>

      <div className="a4-section2">
        <div className="a4-img1">
          <img
            src={require("../../assets/images/33.png")}
            alt="DAL"
            className="dal4_img2"
            data-aos="fade-up-right"
          />
        </div>
        <div className="a4-info2">
          <div className="a4-main-title1" data-aos="fade-up-left">WHAT WE DO</div>

          <div className="a4-sub-text2" data-aos="fade-up-left">
            JKSwara Agro Processing Pvt. Ltd. offers our customers wide range of
            pulses. It's impressive to see such a diverse selection of pulses
            available, catering to various culinary preferences and nutritional
            needs. Having a comprehensive product range like this allows our
            customers to find their preferred types of pulses easily, and it
            shows that our company is committed to meeting the demands of the
            market. Additionally, our online presence through the web store,
            jkswara.com, offers convenience for customers to Explore and
            purchase our products from the comfort of their homes. Maintaining a
            hygienic processing environment is a crucial aspect of ensuring the
            exceptional quality of our products, and it's great to hear that our
            company, places a strong emphasis on this. High-quality products not
            only satisfy customers but also contribute to building a strong
            reputation in the market.
          </div>
        </div>
      </div>
      {/* <div className="a4-section2-res">
        <div className="a4-img1">
          <img
            src={require("../../assets/images/33.png")}
            alt="DAL"
            className="dal4_img2"
          />
        </div>
        <div className="a4-info2">
          <div className="a4-main-title1">WHAT WE DO</div>

          <div className="a4-sub-text2">
            JKSwara Agro Processing Pvt. Ltd. offers our customers wide range of
            pulses. It's impressive to see such a diverse selection of pulses
            available, catering to various culinary preferences and nutritional
            needs. Having a comprehensive product range like this allows our
            customers to find their preferred types of pulses easily, and it
            shows that our company is committed to meeting the demands of the
            market. Additionally, our online presence through the web store,
            jkswara.com, offers convenience for customers to Explore and
            purchase our products from the comfort of their homes. Maintaining a
            hygienic processing environment is a crucial aspect of ensuring the
            exceptional quality of our products, and it's great to hear that our
            company, places a strong emphasis on this. High-quality products not
            only satisfy customers but also contribute to building a strong
            reputation in the market.
          </div>
        </div>
      </div> */}
    </section>
  );
};

export default About4;
